import React, { useContext } from 'react';
import { connect } from 'react-redux';
import GiftCard from '../../components/giftcard/wrapper/GiftCard';
import { GIFT_CARD_IMG, WALLET_IMG } from '../../config/constants/images';
import {
  GIFT_CARD_TITLE,
  GIFT_CARD_TEXT,
  GIFT_CARD_WALLET,
} from '../../config/text/text';
import GiftLayout from '../../layouts/GiftLayout';
import ThemeContext from '../../providers/ThemeProvider';
import { getServerSideEssentials } from '../../redux/actions/ssr';
import { wrapper } from '../../redux/store/store';

const GiftCardPage = () => {
  const theme = useContext(ThemeContext);
  const { giftCardTxt, redeemTxt } = GIFT_CARD_TEXT;
  const { giftCardTitle, redeemTitle } = GIFT_CARD_TITLE;

  const giftCardData = {
    infoCard: {
      giftCardTitle,
      giftCardTxt,
    },
    redeemCard: {
      claimGiftImg: GIFT_CARD_IMG[process.env.NEXT_PUBLIC_SITE],
      claimGiftImgAlt: giftCardTitle,
      redeemTitle,
      redeemTxt,
    },
    walletCard: GIFT_CARD_WALLET,
    walletImg: WALLET_IMG[process.env.NEXT_PUBLIC_BRAND],
  };

  return (
    <div className="gift-card__layout">
      <GiftCard {...giftCardData} />
      <style jsx>{`
        .gift-card__layout {
          padding-top: 40px;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .gift-card__layout {
            padding-top: 0;
          }
        }
      `}</style>
    </div>
  );
};

GiftCardPage.layout = GiftLayout;

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ req, store }) => {
    await store.dispatch(getServerSideEssentials(req.url)).catch((error) => {
      console.log(`getServerSideEssentials error: ${error}`);
    });
  },
);

export default connect()(GiftCardPage);
